import { render, staticRenderFns } from "./ProformeProductieRO.vue?vue&type=template&id=0ec8f924&scoped=true"
import script from "./ProformeProductieRO.vue?vue&type=script&lang=js"
export * from "./ProformeProductieRO.vue?vue&type=script&lang=js"
import style0 from "./ProformeProductieRO.vue?vue&type=style&index=0&id=0ec8f924&prod&lang=css"
import style1 from "./ProformeProductieRO.vue?vue&type=style&index=1&id=0ec8f924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec8f924",
  null
  
)

export default component.exports